const options: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

export function formatDate(dateNumber: number) {
  const date = new Date(dateNumber);
  return date.toLocaleString("nl-BE", options);
}
